export default function BidSearchIcon({
  className = 'fill-black',
}: {
  className?: string
}) {
  return (
    <svg
      className={className}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.3846 9.49997C11.2088 8.4583 11.6209 7.20832 11.6209 5.87499C11.6209 2.62499 9.02471 0 5.81043 0C2.59614 0 0 2.62499 0 5.87499C0 9.12499 2.59614 11.75 5.81043 11.75C7.21152 11.75 8.53023 11.25 9.60166 10.3333L14.217 15L15 14.2083L10.3846 9.49997ZM10.5082 5.87499C10.5082 8.49999 8.40658 10.625 5.81043 10.625C3.21427 10.625 1.11262 8.49999 1.11262 5.87499C1.11262 3.24999 3.21427 1.12498 5.81043 1.12498C8.40658 1.12498 10.5082 3.24999 10.5082 5.87499Z" />
    </svg>
  )
}
